/* Animate each plot once, when it becomes visible, including editor reloads. */
if (!customElements.get('berberine-study-chart')) {
  customElements.define('berberine-study-chart', class extends HTMLElement {
    connectedCallback() {
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.motionPreference.matches || !window.IntersectionObserver || !Element.prototype.animate) return;
      this.animations = [];
      this.playedPlots = this.playedPlots || new WeakSet();
      this.finishAnimations = () => this.animations.forEach(animation => animation.finish());
      this.motionPreference.addEventListener('change', this.onMotionChange = event => {
        if (event.matches) {
          this.observer.disconnect();
          this.finishAnimations();
        }
      });
      this.observer = new IntersectionObserver(entries => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          const animations = this.plotAnimations.get(entry.target);
          animations.forEach(animation => animation.play());
          this.playedPlots.add(entry.target);
          this.observer.unobserve(entry.target);
        }
      }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
      this.plotAnimations = new Map();
      this.querySelectorAll('.berberine-chart__svg').forEach(plot => {
        if (this.playedPlots.has(plot)) return;
        const curves = plot.querySelectorAll('.berberine-chart__curve');
        if (!curves.length) return;
        const animations = [];
        curves.forEach(curve => {
          // Reveal in the curve's own bounding box. Dash lengths use different
          // units under non-scaling-stroke and can stop short on resized SVGs.
          const reveal = curve.animate([
            { clipPath: 'inset(-8px 100% -8px -8px) fill-box' },
            { clipPath: 'inset(-8px -8px -8px -8px) fill-box' }
          ], { duration: 1200, easing: 'ease-in-out', fill: 'both' });
          // Leave the completed path entirely unmasked, including its end cap.
          reveal.onfinish = () => reveal.cancel();
          animations.push(reveal);
        });
        const markers = plot.querySelectorAll('.berberine-chart__dot');
        markers.forEach((marker, index) => {
          const delay = (index % 2) * 1000;
          animations.push(marker.animate([{ opacity: 0 }, { opacity: 1 }], {
            duration: 240, delay, fill: 'both', easing: 'ease-out'
          }));
        });
        animations.forEach(animation => animation.pause());
        this.animations.push(...animations);
        this.plotAnimations.set(plot, animations);
        this.observer.observe(plot);
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      if (this.onMotionChange) this.motionPreference.removeEventListener('change', this.onMotionChange);
    }
  });
}
